module.exports = __webpack_public_path__ + "img/ico-referanslar.ac76b697.svg";